import { Environment } from '@react-three/drei'
import { useMontage } from '../../context/montage.context'
import { House } from './static/House'

export const StaticScene = ({ ...props }): JSX.Element => {
  const { night } = useMontage()
  return (
    <group position={[1.9, 0, 0]}>
      <Environment
        background={true}
        preset={night?.night === true ? 'night' : undefined}
        files={'texture/HDR_Kulisse_final_1500x750_2.93MB.hdr'}
      ></Environment>
      <House></House>
    </group>
  )
}
